// extracted by mini-css-extract-plugin
export default {"wrapper":"KindergartenElements_wrapper__iFX9t"};